import { gql } from "@apollo/client";

export const GET_POST_STOCK = gql`
  query PostStock($where: PostStockWhereInputOne!) {
  postStock(where:$where) {
      id
      amount
      amountAll
      fbFeedId
      post{
        id
      }
      stock {
        id
        name
        price
        amount
        image
        optionValues {
          id
          name
          value
        }
      }
      isPublished
      cfMessage
      createdAt
      updatedAt
      note
  }
}
`;

export const GET_POST_STOCKS = gql`
  query PostStocks($where: PostStockWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  postStocks(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      amount
      amountAll
      fbFeedId
      stock{
        id
        name
        amount
        price
        originPrice
        currency
        image
        isDeleted
        optionValues {
          id
          name
          value
        }
      }
      isPublished
      cfMessage
      createdAt
      updatedAt
      note
    }
  }
}
`;